<template>
    <div class="carousel-management">
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="跳转地址: " prop="redirectUrl">
                    <el-input v-model="dialog.content.redirectUrl" placeholder="请输入跳转地址"></el-input>
                </el-form-item>
                <el-form-item label="跳转类型: " prop="redirectType">
                    <el-input v-model="dialog.content.redirectType" placeholder="请输入跳转类型"></el-input>
                </el-form-item>
                <el-form-item label="轮播图: " prop="imageUrl">
                    <el-upload
                        :action="imageUploadUrl"
                        :headers="{'X-token': token}"
                        :show-file-list="false"
                        :on-success="handleUploadSuccess">
                        <el-button type="primary" size="small">
                            <i class="el-icon-plus"></i>
                            选择图片
                        </el-button>
                    </el-upload>
                    <img :style="{
                        'width': '100%'
                    }" v-if="dialog.content.imageUrl != ''" :src="'https://www.7amdancestudio.cn/image/' + dialog.content.imageUrl">
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>

        <div class="el-card-title">
            <span>轮播图列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="新增轮播图" placement="top">
                    <el-button type="text" @click="handleInsertImage">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <div class="image-item" 
             v-for="image in imageList" 
             :key="image.imageId">
             <img :src="'https://www.7amdancestudio.cn/image/' + image.imageUrl">
             <div class="cover-wrapper">
                <p >跳转链接：{{ image.redirectUrl ? image.redirectUrl : '-' }}</p>
                <p >跳转类型：{{ image.redirectType ? image.redirectType : '-'}}</p>
                <el-tooltip content="删除图片">
                    <el-button class="delete-image" type="text" @click="handleDeleteImage(image.imageId)">
                        <i class="iconfont icon-delete-full"></i>
                    </el-button>
                </el-tooltip>
             </div>
        </div>

    </div>
</template>

<script>
import { CarouselManagementApi } from '../http/carouselManagement/carouselManagement'
import { FileApi } from '../http/file';

export default {
    name: "carousel-management",
    data(){
        return {
            imageList: [],
            dialog: {
                visible: false,
                title: "",
                content: {
                    redirectUrl: "",
                    redirectType: "",
                    imageUrl: ""
                }
            },
            imageUploadUrl: FileApi.imageUpload,
            // 认证token
            token: ""
        }
    },
    mounted(){
        this.token = localStorage.getItem('authToken');
        this.getImageList();
    },
    methods: {
        getImageList(){
            CarouselManagementApi.getCarouselImageList().then(res => {
                this.imageList = res;
            })
        },
        handleInsertImage(){
            this.dialog.visible = true;
            this.dialog.title = "新增轮播图";
        },
        handleDeleteImage(id){
            this.$confirm('是否删除该轮播图?', '删除轮播图', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                CarouselManagementApi.deleteImage(id).then(res => {
                    if(res.data.status === 200){
                        this.$notify.success({ title: '轮播图成功删除'});
                        this.getImageList();
                    }
                })
            }).catch(() => {});
        },
        handleCancel(){
            this.dialog.visible = false;
            for(let key in this.dialog.content){
                this.dialog.content[key] = "";
            }
        },
        handleUploadSuccess(res){
            this.dialog.content.imageUrl = res.content;
        },
        submit(){
            CarouselManagementApi.insertImage(this.dialog.content).then(res => {
                if(res.data.status === 200){
                    this.$notify.success({ title: '新增轮播图成功'});
                    this.handleCancel();
                    this.getImageList();
                }
            })
        }
    }
}
</script>

<style lang="less">
div.carousel-management{
    // padding: 14px 20px;
    div.image-item{
        margin: 0 0 1.6rem 1.6rem;
        width: calc(25% - 2rem);
        display: inline-flex;
        position: relative;
        div.cover-wrapper{
            background: rgba(0, 0, 0, .3);
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            p{
                margin: 1.2rem 0 0 1.2rem;
                font-weight: bold;
                color: #fff;
            }
            .delete-image{
                position: absolute;
                bottom: 1.2rem;
                right: 1.2rem;
                padding: 0;
                i{
                    font-size: 2rem;
                    color: #fff;
                }
            }
        }
        img{
            width: 100%;
        }
    }
}
</style>